import React, { useState, useEffect } from "react";
import { Form, Modal, Table, Button } from "react-bootstrap";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import MenuItem from "@material-ui/core/MenuItem";
import { FormControl, Select, InputLabel, TextField } from "@material-ui/core";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import SelectFilter from "../../../reusableComponents/selectFilter";
import axios from "axios";
import { serverApi } from "../../../../config/Keys";
import isEmpty from "../../../../store/validation/is-Empty";
import moment from "moment";
import {
  NEW_PAYMENT_TYPE,
  ORDER_STATUS,
  ORDER_TYPE,
  PAYMENT_TYPE,
} from "../../../../enums/OrderEnums";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { amApi } from "../../../../api/apiHelper";

const SuperAdminDunzoTransactions = ({ ...props }) => {
  const history = useHistory();
  const id =
    history.location.pathname.split("/")[
    history.location.pathname.split("/").length - 1
    ];
  const [orderData, setOrderData] = useState([]);
  const [balanceStat, setBalanceState] = useState(0);
  const [search, setSearch] = useState("");
  const [dateQuery, setDateQuery] = useState({});

  const auth = useSelector((state) => {
    return !isEmpty(state.auth) ? state.auth.user : "";
  });

  const getReportData = async (dateQuery) => {
    let data = await axios.get(`${serverApi}/dunzoTransactions`, {
      params: { ...dateQuery },
      headers: {
        Authorization: auth.accessToken,
        "Content-Type": "application/json",
      },
    });
    if (data.data) {
      setOrderData(data.data);
    }
  };

  const getBalance = async () => {
    let data = await axios.get(`${serverApi}/dunzoTransactions?getBalance=true`, {
      headers: {
        Authorization: auth.accessToken,
        "Content-Type": "application/json",
      },
    });
    if (data.data) {
      setBalanceState(data.data?.balance || 0);
    }
  };

  useEffect(() => {
    getBalance();
  }, [])

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
    getReportData(data);
  };

  const renderData = orderData.filter((item) => {
    return (
      item?.type.toLowerCase().includes(search.toLowerCase()) ||
      item?.adminId?.userId
        .toLowerCase()
        .includes(search.toLowerCase()) ||
      item?.amount
        .toLowerCase()
        .includes(search.toLowerCase())
    );
  });

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation

            />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Dunzo Transactions
                </div>
                <div>
                  <div
                    className="f14-700 mb-2"
                    align="right"
                    style={{ color: "#EE3A23" }}
                  >
                    {moment().format("[Today,] Do MMM YYYY")}
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <RightSideCountTop
                      content={[
                        {
                          name: "Credit Balance",
                          value: `₹ ${balanceStat
                            ? (balanceStat)
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, "$&,")
                            : 0
                            }`,
                          backgroundColor: "#FFEDE9",
                          color: "#EE3A23",
                        }
                      ]}
                    />
                    <AddCredit getBalance={getBalance} getReportData={getReportData}/>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="amSearch"
                  />
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler()} />
                  </div>
                </div>
              </div>
              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table className="HideShowTable enMinWidth900">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "10%" }} className="f12-700">
                          Transaction Type
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Admin ID / Email
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Order ID
                        </th>
                        <th style={{ width: "8%" }} className="f12-700">
                          Amount
                        </th>
                        <th style={{ width: "8%" }} className="f12-700">
                          Balance
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Transaction Date
                          <br /> & Time
                        </th>
                      </tr>
                    </thead>
                    {renderData &&
                      renderData.map((data) => (
                        <tbody>
                          <tr className="super_admin_all_users_table_body">
                            <td style={{ width: "10%" }} className="f12-400">
                              <div className="f12-400">
                                {data?.type || ""}</div>
                            </td>
                            <td style={{ width: "15%" }} className="f12-400">
                              <div className="f12-400">{data?.adminId?.userId || 'N/A'}
                                <br />
                                {data?.adminId?.email || 'N/A'}</div>
                            </td>
                            <td style={{ width: "10%" }} className="f12-400">
                              <div className="f12-400">{data?.orderRequestId || "N/A"}</div>
                            </td>
                            <td style={{ width: "8%" }} className="f12-400">
                              <div className="f12-400"> {`₹ ${data?.amount || 0}`}</div>
                            </td>
                            <td style={{ width: "8%" }} className="f12-400">
                              <div className="f12-400"> {`₹ ${data?.balance || 0}`}</div>
                            </td>
                            <td style={{ width: "10%" }} className="f12-400">
                              <div className="f12-400"> {moment(data?.createdAt).format("ll")}</div>
                              <div className="f12-400"> {moment(data?.createdAt).format("LT")}</div>
                            </td>
                          </tr>
                        </tbody>
                      ))}
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const AddCredit = ({getBalance, getReportData}) => {
  const [state, setState] = useState(false);
  const handleClose = (e) => setState(!state);
  const [credit, setCredit] = useState("");

  const handleClick = () => {
    setState(true);
  };

  const addCredit = async () => {
    let data = await amApi.post('/dunzoTransactions', { creditAmount: credit });
    setState(false);
    getBalance();
    getReportData();
  }

  return (
    <React.Fragment>
      <div
        className="btn addBtnRed btn2 btn-lg ml-3"
        style={{ borderRadius: "30px" }}
        onClick={handleClick}
      >
        Add Credit
      </div>
      <Modal show={state} onHide={handleClose} centered>
        <Modal.Header className="border-0" closeButton>
          <div className="f24-700">Enter the Credit Amount</div>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="f24_700_HelveticaNeue w-75 m-auto pb-4"></div> */}
          <div className="f18-500 mt-2 mb-4">
            <Form.Group className="pb-4">
              <div className="f14-500 mr-2 my-2"> Add Credit</div>
              <NewInputText
                id="credit"
                label="Credit"
                type="number"
                min={1}
                variant="outlined"
                className={`w-100`}
                name="creditAmount"
                onChange={(e) => setCredit(e.target.value)}
              />
            </Form.Group>
          </div>
          <div className="mt-4">
            <div className="row">
              <div className="col-2"></div>
              <div className="col-4">
                <Button
                  variant="outline-secondary"
                  className="btn-md py-2 mb-2"
                  style={{ width: "90%" }}
                  onClick={handleClose}
                >
                  Cancel
                </Button>
              </div>
              <div className="col-4">
                <Button
                  variant="danger"
                  className="btn-md py-2 mb-2 w-100"
                  onClick={addCredit}
                >
                  Confirm
                </Button>
              </div>
              <div className="col-2"></div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default SuperAdminDunzoTransactions;
